import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles, Button, Markdown, Text, useTheme } from '@Sage/hoi-poi-ui';

import styles from './styles/AddOnBanner';

const useStyles = createUseStyles(styles, 'AddOnBanner');

const AddOnBanner = ({ schema, linkCallback }) => {
    const theme = useTheme();
    const { bgImgSrc, className, content, cta, logo, img, title } = schema;

    const classes = useStyles();

    return (
        <div className={classNames(classes.root, className)}>
            <div className={classes.container}>
                <div className={classes.pic}>{img}</div>
                <div className={classes.main}>
                    <div className={classes.header}>
                        {logo}
                        <Text type="h3" className={classes.title}>
                            {title}
                        </Text>
                    </div>
                    {content && (
                        <Markdown
                            className={classes.content}
                            content={content}
                            overrides={{
                                a: { target: '_blank' },
                                p: { color: theme.colors.textLight.secondary },
                            }}
                            linkCallback={linkCallback}
                        />
                    )}
                    {cta?.length && (
                        <div className={classes.footer}>
                            {cta.map((button, index) => (
                                <Button type={button.type} onClick={button.onClick} key={index}>
                                    {button.text}
                                </Button>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            {bgImgSrc && (
                <div className={classes.bg}>
                    <img src={bgImgSrc} alt="" />
                </div>
            )}
        </div>
    );
};

AddOnBanner.propTypes = {
    linkCallback: PropTypes.func,
    schema: PropTypes.shape({
        bgImgSrc: PropTypes.string,
        className: PropTypes.string,
        title: PropTypes.string.isRequired,
        content: PropTypes.string,
        logo: PropTypes.node,
        cta: PropTypes.arrayOf(
            PropTypes.shape({
                type: PropTypes.oneOf(['primary', 'secondary']),
                text: PropTypes.string,
                onClick: PropTypes.func,
            }),
        ),
        img: PropTypes.shape({
            src: PropTypes.string,
            alt: PropTypes.string,
        }),
    }).isRequired,
};

export default memo(AddOnBanner);
